module.exports = __webpack_public_path__ + "media/flags/tv-d2359d51.svg";